import { ThemeProvider } from '@mui/material'
import { LicenseInfo } from '@mui/x-license-pro'
import { Provider } from 'react-redux'
import { Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, BarController, BarElement, LineController, LineElement, PointElement } from 'chart.js'
import { ResponsiveDetection } from './components/ResponsiveDetection'
import { AppBody } from './components/AppBody/AppBody'

import store from './redux/store'
import theme from './theme/theme'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY!)

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,

    // Bar
    BarController,
    BarElement,

    // Line
    LineController,
    LineElement,
    PointElement,
  )

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ResponsiveDetection />
        <AppBody />
      </ThemeProvider>
    </Provider>
  )
}

export default App
